import { render } from "./produce.vue?vue&type=template&id=368d2c51&scoped=true"
import script from "./produce.vue?vue&type=script&lang=js"
export * from "./produce.vue?vue&type=script&lang=js"

import "./produce.vue?vue&type=style&index=0&id=368d2c51&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368d2c51"]])

export default __exports__